import type { CreateWorkflowInput, UpdateWorkflowInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import { createWorkflow, deleteWorkflow, updateWorkflow } from '../services/workflows-admin.service'

export const useCreateWorkflowMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateWorkflowInput) => await createWorkflow(payload),
    onSuccess: () => {
      toast.success('Flujo de trabajo creado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.workflows.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateWorkflowMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateWorkflowInput }) =>
      await updateWorkflow(id, payload),
    onSuccess: () => {
      toast.success('Flujo de trabajo actualizado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.workflows.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteWorkflowMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteWorkflow(id),
    onSuccess: () => {
      toast.success('Flujo de trabajo eliminado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.workflows.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
